import { InfoOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import ActionMenu from "../../../components/mobile/ActionMenu";
import MobileCard from "../../../components/mobile/MobileCard";
import { convertDate, convertToINR } from "../../../helpers/Utils";
import { TOKENS } from "../constants/figmaTokens";
import CustomTooltip from "./CustomTooltip";
import OrderStatusBadge from "./OrderStatusBadge";

const stopPropagation = (e) => e.stopPropagation();

export default function PoInvoiceCard({
  invoice,
  statusLabel,
  statusCode,
  paymentDate,
  rejectReason,
  actions,
  onOpen,
  onCreditNote,
}) {
  const creditNote = invoice.credit_notes?.[0];
  return (
    <MobileCard onClick={onOpen}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={0.5} sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 600,
              lineHeight: "20px",
              color: TOKENS.primaryDefault,
              overflowWrap: "anywhere",
            }}
          >
            {invoice.invoice_no}
          </Typography>
          {rejectReason ? (
            <CustomTooltip title={rejectReason} arrow placement="bottom-start">
              <InfoOutlined
                fontSize="small"
                sx={{ color: TOKENS.onSurfaceSecondary }}
                onClick={stopPropagation}
              />
            </CustomTooltip>
          ) : null}
        </Box>
        <Box sx={{ flexShrink: 0, ml: 0.5 }} onClick={stopPropagation} onKeyDown={stopPropagation}>
          <ActionMenu actions={actions} />
        </Box>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mt={0.25}>
        <Typography sx={{ fontSize: 14, fontWeight: 700, lineHeight: "20px" }}>
          {convertToINR(invoice.invoice_value)}
        </Typography>
        <OrderStatusBadge type={statusCode} label={statusLabel} />
      </Box>
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={1} mt={0.25}>
        <Typography sx={{ fontSize: 12, lineHeight: "16px", color: TOKENS.onSurfaceSecondary }}>
          {convertDate(invoice.invoice_date)} · Paid {convertToINR(invoice.amount_paid)}
          {paymentDate ? ` [${convertDate(paymentDate)}]` : ""}
        </Typography>
        {creditNote ? (
          <Button
            disableRipple
            variant="text"
            onClick={(e) => {
              e.stopPropagation();
              onCreditNote(creditNote);
            }}
            onKeyDown={stopPropagation}
            sx={{
              p: 0,
              minWidth: 0,
              fontSize: 12,
              lineHeight: "16px",
              textTransform: "none",
              textDecoration: "underline",
              color: TOKENS.onSurfaceDefault,
            }}
          >
            CN {creditNote.number}
          </Button>
        ) : null}
      </Box>
    </MobileCard>
  );
}
